<template>
    <div class="box">
        <scenario-selection-confirmation-popup
                ref="confirmationPopup"
                v-bind:scenarios="selectedScenarios"
                @confirm="navigateToSelectedScenarioTemplatesPage"
        >
        </scenario-selection-confirmation-popup>
        
        <div class="box-body">
            <scenario-list v-bind:scenarios="scenarios">
                <template v-slot:="{scenario}">
                    <scenario-list-item
                            :key="scenario.id"
                            v-bind:scenario="scenario"
                            @scenario-selection-changed="onScenarioSelectionChanged(scenario.id, $event)"
                    >
                    </scenario-list-item>
                </template>
            </scenario-list>
            
            <div class="row" v-if="canWrite">
                <div class="col-12 form-group text-right">
                    <button
                        v-if="hasSelectedScenarios"
                            
                        class="btn btn-lg btn-primary"
                        @click="showConfirmationPopup"
                    >
                        {{resource('DmVisualizer_Index_SelectionConfirmationPopup_Title')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import sortScenariosMixin from '../Mixins/sort-scenarios-mixin';
    import resourceMixin from '../../../Util/Mixins/resources';
    
    import dmVisualizerApi from '../../../Api/dm-visualizer';
    import growler from "../../../Util/growler";
    
    import ScenarioList from "./ScenarioList.vue";
    import ScenarioListItem from "./Index/ScenarioListItem.vue";
    import ScenarioSelectionConfirmationPopup from "./Index/ScenarioSelectionConfirmationPopup.vue";
    
    export default {
        name: "index",
        mixins: [sortScenariosMixin, resourceMixin],
        components: {
            ScenarioList,
            ScenarioListItem,
            ScenarioSelectionConfirmationPopup
        },
        beforeCreate() {
            const vm = this;
            
            dmVisualizerApi.listScenarios().then(
                scenarios => vm.scenarios = scenarios,
                err => growler.bootstrapDanger(err)
            );
            
            dmVisualizerApi.validateWritePermission().then(
                canWrite => vm.canWrite = canWrite
            )
        },
        created(){
            this.selectedScenarioIds = [];
        },
        methods: {
            onScenarioSelectionChanged(scenarioId, isSelected){
                //Select a scenario when not yet present in our selectedScenarios
                //Deselect a scenario when present in our selectedScenarios
                const vm = this;
                
                const currentIndex = vm.selectedScenarioIds.indexOf(scenarioId);
                
                if(currentIndex === -1 && isSelected){
                    vm.selectedScenarioIds.push(scenarioId);
                } 
                else if (currentIndex !== -1 && !isSelected){
                    vm.selectedScenarioIds.splice(currentIndex, 1);
                }
            },
            showConfirmationPopup() {
                this.$refs.confirmationPopup.show();
            },
            navigateToSelectedScenarioTemplatesPage(){
                const selectedScenariosTemplatesUrl = dmVisualizerApi.formatTemplatesUrl(this.selectedScenarioIds);
                window.location = selectedScenariosTemplatesUrl;
            }
        },
        computed: {
            hasSelectedScenarios(){
                return !!this.selectedScenarioIds.length;
            },
            selectedScenarios(){
                const vm = this;
                
                const selectedScenarios = vm.scenarios.filter(s => vm.selectedScenarioIds.indexOf(s.id) !== -1);
                return this.sortScenarios(selectedScenarios);
            }
        },
        data: () => ({
            scenarios: [],
            selectedScenarioIds: [],
            canWrite: false
        })
    };
</script>
